document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".odb-slidein-image-container, .item-ori-maincopy");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("slidein-visible");
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: "0px 0px -10% 0px"
  });

  containers.forEach(container => observer.observe(container));
});
